import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, Search, Heart, UserRound, Building2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function BottomNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  const saved = user?.role === "owner"
    ? { to: "/owner", label: "Listings", Icon: Building2, testId: "bottomnav-listings" }
    : { to: user ? "/favorites" : "/login?next=%2Ffavorites", label: "Saved", Icon: Heart, testId: "bottomnav-saved" };

  const items = [
    { to: "/", label: "Home", Icon: Home, end: true, testId: "bottomnav-home" },
    { to: "/listings", label: "Explore", Icon: Search, testId: "bottomnav-explore" },
    saved,
    { to: user ? "/profile" : "/login?next=%2Fprofile", label: "Profile", Icon: UserRound, testId: "bottomnav-profile" },
  ];

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#FDFBF7]/95 backdrop-blur-xl border-t border-[#1A1F2C]/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="bottom-nav"
    >
      <div className="grid grid-cols-4 h-16">
        {items.map(({ to, label, Icon, end, testId }) => (
          <NavLink
            key={label}
            to={to}
            end={end}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors ${isActive ? "text-[#C85A32]" : "text-[#5C6B7A]"}`
            }
          >
            {({ isActive }) => (
              <>
                <span className={`grid place-items-center w-9 h-7 rounded-full transition-colors ${isActive ? "bg-[#C85A32]/10" : ""}`}>
                  <Icon size={20} strokeWidth={isActive ? 2.4 : 1.8} />
                </span>
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
